
import { createClient } from '@supabase/supabase-js';
import { SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY } from './config';

// Создаем клиент Supabase с принудительным прямым подключением
export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  // Принудительно отключаем все прокси
  realtime: {
    params: {
      eventsPerSecond: 2
    }
  }
});

// Экспортируем URL и ключ для обратной совместимости
export const supabaseUrl = SUPABASE_URL;
export { SUPABASE_PUBLISHABLE_KEY };

console.log('✅ Supabase клиент инициализирован с прямым URL:', SUPABASE_URL);
console.log('✅ Realtime WebSocket принудительно установлен на прямой URL');
